export default "__VITE_ASSET__xhAlz0VQ__"